import { ReactNode } from 'react';
import {
  QueryClient,
  QueryClientProvider,
  QueryFunctionContext,
} from 'react-query';

import { get } from './api';

export const queryFn = async ({ queryKey }: QueryFunctionContext) => {
  const [queryString, params] = queryKey as string[];
  return get(queryString, params);
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 10000,
      notifyOnChangeProps: 'tracked',
      queryFn,
    },
  },
});

export const QueryProvider = ({ children }: { children: ReactNode }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
